import React from 'react';
import { AlertHeader } from '../components/sales/AlertHeader';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhyFailsSection } from '../components/sales/WhyFailsSection';
import { OfferSection } from '../components/sales/OfferSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FAQSection } from '../components/sales/FAQSection';
import { StickyFooter } from '../components/sales/StickyFooter';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20 md:pb-0" data-id="element-208">
      <AlertHeader data-id="element-209" />
      <HeroSection data-id="element-210" />
      <LeadSection data-id="element-211" />
      <MechanismSection data-id="element-212" />
      <WhyFailsSection data-id="element-213" />
      <OfferSection data-id="element-214" />
      <GuaranteeSection data-id="element-215" />
      <TestimonialsSection data-id="element-216" />
      <FAQSection data-id="element-217" />

      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm" data-id="element-218">
        <div className="max-w-4xl mx-auto" data-id="element-219">
          <p className="mb-4" data-id="element-220">
            Este producto no sustituye el parecer de un médico profesional.
            Siempre consulte a un médico para tratar asuntos de salud.
          </p>
          <p data-id="element-221">
            &copy; {new Date().getFullYear()} Protocolo de Limpieza Glicémica.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <StickyFooter data-id="element-222" />
    </div>;
}